// extracted by mini-css-extract-plugin
module.exports = {"scorecardMenuHeader":"ScoreCardFolderList_scorecardMenuHeader__1S7M8","scoreCardItem":"ScoreCardFolderList_scoreCardItem__1i-iJ"};